"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PageWithNavbar;
const Page_1 = __importDefault(require("../Page"));
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const variables_1 = __importDefault(require("../../styles/variables"));
const Navbar_1 = __importDefault(require("../Navbar"));
const useStyles = (0, core_1.makeStyles)(() => ({
    page: {
        backgroundColor: variables_1.default.colors.white,
        padding: 0,
    },
    gridContainer: {
        fontFamily: variables_1.default.fonts.family.heading,
        fontStyle: 'normal',
        padding: '1rem',
    },
}));
function PageWithNavbar({ children, withLoginButton, }) {
    const classes = useStyles();
    return (react_1.default.createElement(Page_1.default, { className: classes.page },
        react_1.default.createElement(core_1.Grid, { container: true, className: classes.gridContainer },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Navbar_1.default, { withLoginButton: withLoginButton }))),
        children));
}
